"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckboxLabel = exports.StyledCheckboxField = exports.StyledCheckboxWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCheckboxWrap = styled_components_1.default.div `
  max-width: 100%;
  width: 100%;
  display: flex;
  cursor: ${(props) => (props.disabled ? 'none' : 'pointer')};
  pointer-events: ${(props) => (props.disabled ? 'none' : '')};
  ${(props) => (props.disabled ? 'color: grey;' : '')}

  &:hover {
    color: var(--primary-color, #367bf5);
  }
`;
exports.StyledCheckboxField = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  border: 2px solid
    ${(props) => props.isActive ? 'var(--primary-color, #367bf5)' : props.isError ? 'var(--error-color, #E73030)' : '#212121'};
  box-sizing: border-box;
  cursor: pointer;
  background: ${(props) => props.disabled ? '#E7E7E7' : props.isActive ? 'var(--primary-color, #367bf5)' : 'transparent'};

  &.disabled {
    border-color: #ebebeb;
    background-color: ${(props) => (props.isActive ? ' #EBEBEB' : '#E7E7E7')};
    cursor: unset;
  }

  &[data-variation='secondary'] {
    width: 18px;
    height: 18px;
    border: 1px solid
      ${(props) => props.disabled
    ? '#E7E7E7'
    : props.isActive
        ? 'var(--primary-color, #367bf5)'
        : props.isError
            ? 'var(--error-color, #E73030)'
            : '#c7c7cc'};
    border-radius: 4px;
    margin-right: 16px;
  }
  &[data-variation='tabular'] {
    width: 20px;
    height: 20px;
    border: 2px solid
      ${(props) => props.isActive ? 'var(--primary-color, #367bf5)' : props.isError ? 'var(--error-color, #E73030)' : '#909090'};
  }
`;
exports.StyledCheckboxLabel = styled_components_1.default.span `
  font-size: 16px;
  line-height: 20px;
  color: ${(props) => (props.disabled ? 'inherit' : '#212121')};
  flex: 1;
  max-width: calc(100% - 24px);

  &[data-variation='secondary'] {
    line-height: 18px;
    font-size: 14px;
    color: inherit;
  }
`;
//# sourceMappingURL=input-checkbox.styled.js.map